import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import selectors from '@/selectors';
import NotificationsService from '@/notifications/service';
import datasetNotificationActions from '../constants';
import { createDatasetNotificationSuccess, createDatasetNotificationError } from '../actions';

function createDatasetNotification(code, event, properties) {
  return NotificationsService.create('dataset', code, event, properties)
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
}

export function* create(action) {
  const { datasetName, code, update: updateProperties } = yield select(selectors.datasetNotification);
  const { response, error } = yield call(createDatasetNotification, code, action.event, updateProperties);

  if (error) {
    yield put(createDatasetNotificationError(error));
  } else {
    yield put(createDatasetNotificationSuccess(datasetName, response));
  }
}

export default function* datasetNotificationsApi() {
  yield takeLatest(datasetNotificationActions.CREATE_DATASET_NOTIFICATION, create);
}
